module.exports = __webpack_public_path__ + "static/media/screenMac.06c9e7a6.png";